module.exports = __webpack_public_path__ + "img/chinesecompany201.4081eb5a.png";